import React, { Component } from "react";
import { connect } from "react-redux";
import SidebarList from "features/Admin/components/SidebarList";
import ElementFocus from "features/Admin/components/ElementFocus";
import { adminGetAllCenters } from "services/center";
import { adminGetAllSamplers } from "services/user";
import {
	adminGetAllPartners,
	adminGetPartnerById,
	adminPatchPartner,
	adminPostPartner,
	adminDeletePartner,
	resetFocusPartner,
	initNewPartner,
} from "services/partnerCompany";
import AdminDataContainer from "features/Admin/components/AdminDataContainer";
import { Grid, Icon } from "semantic-ui-react";
import RedButton from "components/Buttons/RedButton";
import GeneralForm from "features/Admin/PartnerCompanies/Forms/GeneralForm";
import { Form, Formik } from "formik";
import MainButton from "components/Buttons/MainButton";
import SecondaryButton from "components/Buttons/SecondaryButton";
import * as Yup from "yup";
import { isJson } from "utils/json";

const schemaValidation = Yup.object().shape({
	name: Yup.string().required("Champ requis"),
});

class PartnerCompaniesAdmin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			centersFactory: {
				list: this.props.centers.list.data.map((i) => {
					return { ...i, code: `${i.name}` };
				}),
				listLabel: "Liste des centres",
				selectedLabel: "Centres liés à cette société partenaire",
				value: [],
			},

			samplersFactory: {
				list:
					this.props.samplers && this.props.samplers.data
						? this.props.samplers.data.map((i) => {
								return { ...i, code: `${i.last_name} ${i.first_name}` };
						  })
						: [],
				listLabel: "Liste des préleveurs disponibles",
				selectedLabel: "Préleveurs externes liés à cette société partenaire",
				value: [],
			},
		};
	}

	updateFactoryValue = (newSelected, name) => {
		this.setState((prevState) => ({
			...prevState,
			[name]: {
				...prevState[name],
				value: newSelected,
			},
		}));
	};

	setupFactories = (elt) => {
		this.setState({
			centersFactory: {
				list: this.props.centers.list.data.map((i) => {
					return { ...i };
				}),
				listLabel: this.state.centersFactory.listLabel,
				selectedLabel: this.state.centersFactory.selectedLabel,
				value:
					elt && elt.centers && elt.centers.length > 0
						? elt.centers.map((i) => {
								return JSON.stringify({ ...i, code: `${i.name}` });
						  })
						: [],
			},
			samplersFactory: {
				list: this.props.samplers.list.data.map((i) => {
					return { ...i };
				}),
				listLabel: this.state.samplersFactory.listLabel,
				selectedLabel: this.state.samplersFactory.selectedLabel,
				value:
					elt && elt.samplers && elt.samplers.length > 0
						? elt.samplers.map((i) => {
								return JSON.stringify({ ...i, code: `${i.login}`, name: `${i.last_name} (${i.first_name})` });
						  })
						: [],
			},
		});
	};

	resetFactories = () => {
		this.setState({
			centersFactory: {
				list: this.state.centersFactory.list,
				listLabel: this.state.centersFactory.listLabel,
				selectedLabel: this.state.centersFactory.selectedLabel,
				value: this.state.centersFactory.value,
			},
			samplersFactory: {
				list: this.state.samplersFactory.list,
				listLabel: this.state.samplersFactory.listLabel,
				selectedLabel: this.state.samplersFactory.selectedLabel,
				value: this.state.samplersFactory.value,
			},
		});
	};

	componentDidMount() {
		this.getAllElements();

		if (this.props.partners.focus.data !== null) {
			this.setupFactories(this.props.partners.focus.data);
		}
	}

	componentWillUnmount() {
		this.props.resetFocusPartner();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllPartners();
		this.props.adminGetAllCenters();
		this.props.adminGetAllSamplers();
	};

	focusOnElement = (elt) => {
		this.props.adminGetPartnerById(elt.id);
	};

	onAddClick = () => {
		this.props.initNewPartner();
	};

	saveFocus = (values, setSubmitting) => {
		values.samplers = this.state.samplersFactory.value
			.filter((s) => isJson(s))
			.map((s) => JSON.parse(s).id)
			.join(",");
		values.centers = this.state.centersFactory.value
			.filter((c) => isJson(c))
			.map((c) => JSON.parse(c).id)
			.join(",");
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostPartner(values).then(() => {
				setSubmitting(false);
				this.resetFactories();
			});
		} else {
			this.props.adminPatchPartner(values).then(() => {
				setSubmitting(false);
				this.resetFactories();
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeletePartnerCompany(this.props.partner.focus.data.id);
	};

	render() {
		const { partners } = this.props;
		const { focus, list } = partners;
		const partner = focus.data;
		const newPartner = partner !== null && partner.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={{
						data: partners.list.data.map((i) => {
							return { ...i, code: `${i.name}` };
						}),
					}}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity="Sociétés de prélèvement partenaires"
					addButtonText="Nouvelle société partenaire"
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.name}
					groupField={false}
					focusedEltId={partner}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity="Sociétés de prélèvement partenaires"
					icon="info"
					//importFunction={this.props.adminImportCenters}
				>
					{partner !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: partner.id,
								name: partner.name || "",
								centers: partner.centers || [],
								samplers: partner.samplers || [],
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors, values }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton type="button" style={{ float: "left" }} onClick={this.props.resetFocusPartner}>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name="save" />}
													type="submit"
													style={{ float: "left" }}
													isSubmitting={isSubmitting}
													disabled={Object.entries(errors).length > 0 && errors.constructor === Object}
												>
													{newPartner ? "Créer" : "Enregistrer"}
												</MainButton>

												{!newPartner && (
													<RedButton
														text={<Icon name="trash" />}
														type="button"
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: "right" }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer ribbonColor="red" ribbonLabel="Général">
													<GeneralForm
														centersFactory={this.state.centersFactory}
														updateCenters={(value) => this.updateFactoryValue(value, "centersFactory")}
														samplersFactory={this.state.samplersFactory}
														updateSamplers={(value) => this.updateFactoryValue(value, "samplersFactory")}
														values={values}
													/>
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: "100%",
		width: "100%",
		paddingTop: 43,
		fontSize: 0,
		display: "flex",
	},
	blocHeader: {
		backgroundColor: "rgb(0, 147, 128)",
		padding: 10,
		width: "100%",
		borderRadius: "4px 4px 0 0",
	},
};

const mapStateToProps = (state) => {
	return {
		samplers: state.admin.samplers,
		centers: state.admin.centers,
		partners: state.admin.partners,
	};
};

const mapDispatchToProps = {
	adminGetAllPartners,
	adminGetPartnerById,
	adminPatchPartner,
	adminDeletePartner,
	resetFocusPartner,
	adminPostPartner,
	initNewPartner,
	adminGetAllCenters,
	adminGetAllSamplers,
};

export default connect(mapStateToProps, mapDispatchToProps)(PartnerCompaniesAdmin);
